import React from 'react';
import { motion } from 'framer-motion';
import { painPoints } from '../data/painPoints';
export function PainPoints() {
  return <section aria-label="Problèmes" className="border-y border-grape/10 bg-white/70" data-id="element-130" data-mp="2lmsqcmz6p8ku">
      <div className="mx-auto max-w-4xl px-5 pb-12 pt-10" style={{
      paddingBottom: '8px'
    }} data-id="element-131" data-mp="26xmsp3fzvqf2">
        <h2 className="text-center font-display text-[25px] font-black text-plum sm:text-4xl" data-id="element-132" data-mp="2bwhaq3651ay4">
          ❓ Vous reconnaissez-vous dans l'une de ces situations ?
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-center text-base leading-relaxed text-plum/70" data-id="element-133" data-mp="21zupvedtajw3">
          Vous adorez les K-Dramas et le K-Pop, vous voulez comprendre ce qu'ils disent réellement,
          mais chaque fois que vous essayez d'apprendre le coréen, vous vous perdez entre les
          symboles, les applications et les listes de vocabulaire aléatoires qui ne mènent nulle
          part.
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-center text-lg font-bold text-grape" data-id="element-134" data-mp="3ncxqjxllttli">
          Ce n'est pas un manque de talent. Ce n'est pas un manque d'effort. C'est un manque de
          système visuel.
        </p>

        <div className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-135" data-mp="1u12e8eij675w">
          {painPoints.map((p, i) => <motion.div key={p.title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i % 2 * 0.08,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex gap-3 rounded-xl border border-grape/15 bg-cream p-5" data-id="element-136" data-mp="27sgz6qw00ifl" data-mpi={i}>
              <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-lilac-soft text-sm" aria-hidden="true" data-id="element-137" data-mp="1p428k4plf6fb">
                {p.emoji}
              </span>
              <div data-id="element-138" data-mp="30jh1mxeole55">
                <h3 className="text-sm font-bold text-plum" data-id="element-139" data-mp="2vj2uriotga8p">{p.title}</h3>
                <p className="mt-1 text-sm leading-relaxed text-plum/65" data-id="element-140" data-mp="2vkxeitocpwb7">{p.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-141" data-mp="1y2x291lkqi05">
          <p className="font-display text-2xl font-bold text-plum sm:text-3xl" data-id="element-142" data-mp="1y62swl9uprxz">
            ✨ Si vous avez répondu OUI à l'une de ces situations, nous avons la solution.
          </p>
          <p className="mt-3 text-lg font-semibold text-blush-deep" data-id="element-143" data-mp="272tvlgiws51j">
            Le jour 60 peut sonner complètement différemment.
          </p>
        </div>
      </div>
    </section>;
}